import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const Footer = () => {
  const navigate = useNavigate();

  const handleNavClick = (e, to) => {
    e.preventDefault();
    navigate(to);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer-new">
      {/* Main Footer Content - Centered Layout */}
      <div className="footer-content-centered">
        {/* Brand */}
        <div className="footer-brand-section">
          <div className="footer-brand-text">
            <span className="footer-brand-main">DOMUS LIVING</span>
            <span className="footer-brand-sub">ARCHITECTURAL DESIGN</span>
          </div>
        </div>
        
        {/* Navigation */}
        <nav className="footer-nav-centered">
          <a href="/" className="footer-link" onClick={(e) => handleNavClick(e, '/')}>Home</a>
          <a href="/projects" className="footer-link" onClick={(e) => handleNavClick(e, '/projects')}>Projects</a>
          <a href="/studio" className="footer-link" onClick={(e) => handleNavClick(e, '/studio')}>Studio</a>
          <a href="/gallery" className="footer-link" onClick={(e) => handleNavClick(e, '/gallery')}>Gallery</a>
          <a href="/contact" className="footer-link" onClick={(e) => handleNavClick(e, '/contact')}>Contact</a>
        </nav>
        
        {/* Social Icons */}
        <div className="footer-social-centered">
          <a
            href="https://www.linkedin.com/company/domus-living"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-icon"
            aria-label="LinkedIn"
          >
            <Linkedin size={20} />
          </a>
          <a
            href="https://instagram.com/domus.living"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-social-icon"
            aria-label="Instagram"
          >
            <Instagram size={20} />
          </a>
        </div>
      </div>
      
      {/* Footer Bottom */}
      <div className="footer-bottom-centered">
        <p className="footer-copyright-new">
          © {new Date().getFullYear()} Domus Living. All rights reserved.
        </p>
        <div className="footer-contact-info-new">
          <span>enquiries@domusliving.net</span>
          <span className="footer-divider">|</span>
          <span>0417 012 601</span>
        </div>
      </div>
    </footer>
  );
};
